import React, {FC, useReducer, useRef} from 'react'
import {ImportList, InsertList} from '../../../app/pages/mailing'
import {Modal} from './Modal'

enum ActionType {
    IMPORT = 'IMPORT',
    INSERT = 'INSERT',
}

type Action = {type: ActionType}

type State = {selectedType: ActionType, element: JSX.Element,}

const CreateContactListMailing = () => {

    return (
        <>
            <Modal
                button={{
                    bg: 'primary',
                    tooltip: 'Créer',
                    text: "Nouvelle liste",
                    icon: {show: true, svg: 'abstract/abs011'},
                }}
                modal={{
                    id: `create_contact_list`,
                    size: 'lg',
                    content: <Content />,
                }}
            />

            {/*<div className="text-center">*/}
            {/*    <button type="button"*/}
            {/*            className="btn btn-sm btn-light-primary btn-flex btn-active-primary"*/}
            {/*            data-bs-toggle="modal"*/}
            {/*            data-bs-target="#kt_modal_create_contact_list"*/}
            {/*            aria-describedby="control-id-click"*/}
            {/*    >*/}
            {/*        <KTSVG path="/media/icons/duotune/abstract/abs011.svg"*/}
            {/*               className="svg-icon svg-icon svg-icon-3" />*/}
            {/*        Nouvelle liste*/}
            {/*    </button>*/}
            {/*</div>*/}
            {/*<div className="modal fade" id="kt_modal_create_contact_list" aria-hidden="true" ref={modalRef}>*/}
            {/*    <div className="modal-dialog modal-dialog-centered mw-900px">*/}
            {/*        <div className="modal-content">*/}
            {/*            */}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    )
}

export {CreateContactListMailing}

const Content = () => {

    const closeRef = useRef<HTMLButtonElement | null>(null)

    const initialState: State = {
        element: <ImportList closeRef={closeRef} />,
        selectedType: ActionType.IMPORT,
    }
    const reducer = (state: State, action: Action): State => {
        switch (action.type) {
            case ActionType.IMPORT:
                return {selectedType: ActionType.IMPORT, element: <ImportList closeRef={closeRef} />}
            case ActionType.INSERT:
                return {selectedType: ActionType.INSERT, element: <InsertList closeRef={closeRef} />}
            default:
                return state
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    return (
        <>
            <div className="modal-header"><h5 className="modal-title">Source de la liste</h5></div>
            <div className="modal-body">
                <div className="row py-3 mb-10">
                    <div className="col-6">
                        <RadioButton id="import"
                                     label="Importer un fichier"
                                     description="Format CSV, TXT ou RTF."
                                     checked={state.selectedType === ActionType.IMPORT}
                                     onChange={() => dispatch({type: ActionType.IMPORT})}
                        />
                    </div>
                    <div className="col-6">
                        <RadioButton id="insert"
                                     label="Insérer manuellement"
                                     description="Copier et coller des contacts."
                                     checked={state.selectedType === ActionType.INSERT}
                                     onChange={() => dispatch({type: ActionType.INSERT})}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div id="kt_source_edit" className={'flex-row-fluid '}>
                            <div className="card border border-gray-300 border-dashed"
                                 style={{boxShadow: '0 0 20px rgba(82, 63, 105, .06)'}}>
                                <div className="card-body p-2 p-md-6">{state.element}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

type RadioButtonProps = {
    id: string;
    label: string;
    description: string;
    checked: boolean;
    onChange: () => void;
}

const RadioButton: FC<RadioButtonProps> = ({id, label, description, checked, onChange}) => (
    <div className="row">
        <div className="col-2 d-flex justify-content-center align-items-center">
            <div className="form-check form-check-custom form-check-solid form-check-sm">
                <input
                    className="form-check-input"
                    type="radio"
                    id={id}
                    name="radio_btn"
                    checked={checked}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="col-10 d-flex justify-content-start align-items-start">
            <div className="d-flex flex-column">
                <label className="form-check-label cursor-pointer" htmlFor={id}>
                    <div className="fw-bolder text-gray-800">{label}</div>
                    <div className="text-gray-600 fs-7">{description}</div>
                </label>
            </div>
        </div>
    </div>
)


